import { httpClient } from '@/services/http/httpClient'
import type { Option } from '@/types/option'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

type HttpResponse = {
  period: string
  quantity: number
}[]

type Params = {
  startDate?: Date
  endDate?: Date
  challenges?: string[]
}

type Response = {
  ideasByMonth: Option<number>[]
}

async function getDashboardIdeasByMonth({
  startDate,
  endDate,
  challenges,
}: Params): Promise<Response> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      ideasByMonth: [
        {
          label: 'Jan/2025',
          value: 10,
        },
        {
          label: 'Fev/2025',
          value: 20,
        },
      ],
    }
  }

  const queryParams = new URLSearchParams({
    ...(startDate && { startDate: startDate.toISOString() }),
    ...(endDate && { endDate: endDate.toISOString() }),
    ...(challenges && { campaignIds: JSON.stringify(challenges) }),
  })

  const query = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data } = await httpClient.get<HttpResponse>(
    `/ideas/dashboard/ideas-per-month${query}`,
  )

  return {
    ideasByMonth: data.map(({ period, quantity }) => ({
      label: period,
      value: quantity,
    })),
  }
}

export { getDashboardIdeasByMonth }
